module.exports = __webpack_public_path__ + "img/T5-D-xh_16.43c73cdd.png";